import React, { useCallback, useState, useMemo, forwardRef, useEffect } from "react";
import { Input, Select } from "antd";
import { InputProps } from "antd/lib/input";
// import cs from "classnames";
import countries, { ICountry } from "./source";
// Styles
import styles from "./index.module.scss";

const InputGroup = Input.Group;

interface IProps extends InputProps {
	onChangeCountry?: (e: CountryPhoneCodeValue) => void;
}

interface CountryPhoneCodeValue {
	code?: number;
	phone?: string;
	short?: string;
}

const CountryPhoneCode: React.FC<IProps> = ({ className, value, onChangeCountry, ...restProps }: any, ref) => {
	const defaultCountry: ICountry | undefined = useMemo(() => {
		return countries.find(c => c.short === "IR");
	}, []);
	// const [maxLength, setMaxLength] = useState<number>(11);
	// const [placeholder, setPlaceholder] = useState<string>("9123456789");
	const [country, setCountry] = useState<ICountry | undefined>(defaultCountry);

	useEffect(() => {
		triggerChange(country);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const triggerChange = useCallback(
		(country?: ICountry) => {
			const result: CountryPhoneCodeValue = {
				phone: value,
				code: country && Number(country.phoneCode),
				short: country && country.short,
			};
			onChangeCountry(result);
		},
		[onChangeCountry, value],
	);

	const handleCountryChange = useCallback(
		(value: string) => {
			const c = countries.find(c => c.short === value);
			if (!c) {
				throw new Error(`Country not found: ${value}`);
			}
			setCountry(c);
			triggerChange(c);
			// switch (c.short) {
			// 	case "IR":
			// 		setMaxLength(11);
			// 		setPlaceholder("9123456789");
			// 	case "DE":
			// 		setMaxLength(10);
			// 		setPlaceholder("1771789427");
			// 	case "AE":
			// 		setMaxLength(9);
			// 		setPlaceholder("9123456789");
			// 	case "TR":
			// 		setMaxLength(10);
			// 		setPlaceholder("9123456789");
			// 	default:
			// 		setMaxLength(11);
			// 		setPlaceholder("1771789427");
			// }
		},
		[setCountry, triggerChange],
	);

	return (
		<InputGroup compact className={styles["input-group"]}>
			<Select
				showSearch
				optionLabelProp="label"
				className={styles["select"]}
				onChange={handleCountryChange}
				dropdownMatchSelectWidth={false}
				defaultValue={country && country.short}
			>
				{countries.map(item => {
					const fix = {
						key: item.short,
						value: item.short,
						label: `${item.emoji} +${item.phoneCode}`,
					};
					return (
						<Select.Option {...fix} className={styles["select-option"]}>
							{fix.label}
						</Select.Option>
					);
				})}
			</Select>
			<Input ref={ref} bordered={false} maxLength={11} style={{ width: "calc(100% - 100px)" }} {...restProps} />
		</InputGroup>
	);
};

// @ts-ignore
export default forwardRef(CountryPhoneCode);
